const state = {
  list: [],
  pagination: [],
  formSend: false,
  reloadList: false,
};

export default state;
